import React, {Fragment} from "react";
import {connect} from "react-redux";
import {Col, Collapse, Form, Input, message, Modal, Popconfirm, Row, Space, Table, Upload} from "antd";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import Button from "antd/es/button";
import {DeleteOutlined, EyeOutlined} from "@ant-design/icons";
import {displayErrors, normalizeEnum} from "../../libs/utils";
import {
    deleteSoftwarePresetGroup,
    deleteSoftwarePresetGroupItem,
    uploadCustomSoftwarePresetItem
} from "../../actions/domains";
import AccessItem from "../permissions/AccessItem";
import {ImWordpress} from "react-icons/im";
import {FiUpload} from "react-icons/fi";

class SoftwarePresetGroupTable extends React.Component {
    state = {
        loading: false,
        activeGroup: null,
        showUploadModal: false,
        uploadGroupId: null,
        uploadGroupType: null,
        uploadItemName: '',
        uploadFile: null,
        deletingItem: null,
        deletingGroup: null,
    };

    deletePresetGroup() {
        this.setState({ deletingGroup: this.state.activeGroup });

        this.props.deleteSoftwarePresetGroup(this.props.activePreset, this.state.activeGroup, () => {

            this.setState({ loading: false, activeGroup: null, deletingGroup: null });
            message.success('Group successfully deleted!');
            this.props.reloadPresets();

        }, (err) => {
            this.setState({ loading: false, deletingGroup: null });

            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
            }
        });
    }

    getItemUrl(slug, itemType) {
        if(itemType === 'THEME') {
            return 'https://wordpress.org/themes/' + slug + '/';
        } else if(itemType === 'PLUGIN') {
            return 'https://wordpress.org/plugins/' + slug + '/';
        }
    }

    deleteItem(guid) {
        return new Promise((resolve, reject) => {
            this.props.deleteSoftwarePresetGroupItem(
                this.props.activePreset,
                this.props.activeGroup,
                guid,
                () => {
                    message.success('Item successfully deleted!');
                    resolve();
                    this.props.reloadPresets();
                },
                (err) => {
                    if (err.response) {
                        displayErrors(err.response.data);
                    }

                    reject(err);
                }
            );
        });
    }

    closeUploadModal() {
        this.setState({
            loading: false,
            activeGroup: null,
            showUploadModal: false,
            uploadGroupId: null,
            uploadGroupType: null,
            uploadItemName: '',
            uploadFile: null,
            deletingItem: null,
            deletingGroup: null,
        })
    }

    uploadProps = {
        name: 'file',
        multiple: false,
        maxCount: 1,
        accept: '.zip',

        beforeUpload: (file) => {
            if (!file.name.toLowerCase().endsWith('.zip')) {
                message.error('Only ZIP files are allowed.');
                return Upload.LIST_IGNORE;
            }

            if (file.size > 30 * 1024 * 1024) {
                message.error('Maximum file size is 30MB.');
                return Upload.LIST_IGNORE;
            }

            this.setState({ uploadFile: file });

            return false;
        },

        onRemove: () => {
            this.setState({ uploadFile: null });
        }
    };

    uploadCustomItem() {
        const { uploadFile, uploadItemName, uploadGroupId } = this.state;

        if (!uploadFile || !uploadItemName.trim()) {
            message.error('Please provide a name and ZIP file.');
            return;
        }

        const file = uploadFile.originFileObj || uploadFile;

        const data = new FormData();
        data.append('name', uploadItemName.trim());
        data.append('file', file, file.name);

        for (const [key, value] of data.entries()) {
            console.log(key, value);
        }

        this.setState({ loading: true });

        this.props.uploadCustomSoftwarePresetItem(
            this.props.activePreset,
            uploadGroupId,
            data,
            () => {
                message.success('Custom item uploaded successfully.');
                this.closeUploadModal();
                this.props.reloadPresets();
            },
            (err) => {
                this.setState({ loading: false });

                if (err.response) {
                    displayErrors(err.response.data);
                } else {
                    message.error('Upload failed.');
                }
            }
        );
    }

    render() {
        const columns = [
            { title: 'Name', dataIndex: 'name', render: (item, row) => {
                if(row.slug === null) {
                    return item;
                }

                return <a href={this.getItemUrl(row.slug, row.item_type)} target='_blank' rel='noopener noreferrer'>{item}</a>;
            }},
            { title: 'Type', align: 'center', dataIndex: 'item_type', render: (item) => normalizeEnum(item)},
            { title: '', align: 'right', render: (item, row) => <Space>
                    <a href={this.getItemUrl(row.slug, row.item_type)} target='_blank' rel='noopener noreferrer'>
                        <Button icon={<EyeOutlined />} size='small'>Preview</Button>
                    </a>
                    <AccessItem scopes={['can_edit_software_presets']}>
                        <Popconfirm
                            title="Are you sure you want to delete this item?"
                            onConfirm={() => this.deleteItem(row.guid)}
                            okText="Delete"
                            placement="topRight"
                            okButtonProps={{ danger: true }}
                            cancelText="Cancel">
                            <Button icon={<DeleteOutlined />} danger size="small" />
                        </Popconfirm>
                    </AccessItem>
                </Space>}
        ];

        const { Panel } = Collapse;
        const { Dragger } = Upload;

        return(
            <Fragment>
                <Row>
                    <Col span={24}>
                        <AccessItem scopes={['can_edit_software_presets']}>
                            <Button icon={<PlusOutlined />} onClick={() => this.props.addGroup() }>Add Group</Button>
                        </AccessItem>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col span={24}>
                        {this.props.data.groups.length > 0 ? <Collapse accordion activeKey={this.props.activeGroup} onChange={(guid) => {
                            this.setState({ activeGroup: guid });
                            this.props.setActiveGroup(guid);
                        }}>
                            {this.props.data.groups.map(group => {
                                return <Panel
                                    header={<span>{group.name} <em><small>({normalizeEnum(group.group_type)} - install {normalizeEnum(group.install_action).toLowerCase()})</small></em></span>}
                                    key={group.guid}>
                                    <Row justify='space-between'>
                                        <Col>
                                            <AccessItem scopes={['can_edit_software_presets']}>
                                                <Space style={{marginBottom: '10px'}}>
                                                    <Button onClick={() => this.props.addItems(group.guid, group.group_type) }>
                                                        <ImWordpress style={{marginBottom: '-2px', marginRight: '3px'}} /> Add {group.group_type === 'PLUGINS' ? 'Plugins' : 'Themes'}
                                                    </Button>
                                                    <Button onClick={() => this.setState({ showUploadModal: true, uploadGroupId: group.guid, uploadGroupType: group.group_type }) }>
                                                        <FiUpload style={{marginBottom: '-2px', marginRight: '3px'}} /> Upload Custom {group.group_type === 'PLUGINS' ? 'Plugin' : 'Theme'}
                                                    </Button>
                                                </Space>
                                            </AccessItem>
                                        </Col>
                                        <Col>
                                            <AccessItem scopes={['can_edit_software_presets']}>
                                                <Popconfirm
                                                    title="Are you sure you want to delete this preset group?"
                                                    onConfirm={() => this.deletePresetGroup()}
                                                    okText='Delete'
                                                    placement='left'
                                                    okButtonProps={{danger: true}}
                                                    cancelText='Cancel'>
                                                    <Button icon={<DeleteOutlined />} danger loading={this.state.deletingGroup === group.guid} disabled={this.state.deletingGroup === group.guid}>Delete Group</Button>
                                                </Popconfirm>
                                            </AccessItem>
                                        </Col>
                                    </Row>

                                    <div style={{overflowX: 'auto'}}>
                                        <Table
                                            dataSource={group.items}
                                            columns={columns} size='small'
                                            rowKey={(item) => item.guid}
                                            pagination={false} />
                                    </div>


                                </Panel>;
                            })}
                        </Collapse> : ''}
                    </Col>
                </Row>

                <Modal
                    title={<span>Upload {this.state.uploadGroupType === 'PLUGINS' ? 'Plugin' : 'Theme'}</span>}
                    centered
                    onCancel={() => this.closeUploadModal()}
                    open={this.state.showUploadModal}
                    footer={
                        <Space>
                            <Button disabled={this.state.loading} onClick={() => this.closeUploadModal()}>
                                Close
                            </Button>

                            <Button
                                type="primary"
                                loading={this.state.loading}
                                disabled={
                                    !this.state.uploadFile ||
                                    !this.state.uploadItemName.trim()
                                }
                                onClick={() => this.uploadCustomItem()}>
                                Upload
                            </Button>
                        </Space>
                    }>
                    <Form layout='vertical'>
                        <Form.Item label={<span>{this.state.uploadGroupType === 'PLUGINS' ? 'Plugin' : 'Theme'} name</span>}>
                            <Input value={this.state.uploadItemName} onChange={(e) => this.setState({ uploadItemName: e.target.value })} />
                        </Form.Item>
                        <Dragger {...this.uploadProps} fileList={this.state.uploadFile ? [this.state.uploadFile] : []}>
                            <p className="ant-upload-text">Click or drag file to this area to upload!</p>
                            <p className="ant-upload-hint">Upload a .zip file that contains your {this.state.uploadGroupType === 'PLUGINS' ? 'plugin' : 'theme'}. Max file size is 30MB.</p>
                        </Dragger>
                    </Form>
                </Modal>
            </Fragment>
        );
    }
}

export default connect(null, { deleteSoftwarePresetGroupItem,
    deleteSoftwarePresetGroup, uploadCustomSoftwarePresetItem })(SoftwarePresetGroupTable);